import { ActionTree } from 'vuex'
import { RootState } from '../../types'

export const actions: ActionTree<RootState, RootState> = {
  setIsSending ({ commit }, payload: boolean) {
    commit('SET_IS_SENDiNG', payload)
  }
}
